import { useMemo } from 'react';
import { useSubscription } from 'use-subscription';
import getAllCookies from '../utils/getAllCookies.js';
import onCookieChanged from '../utils/onCookieChanged.js';
const useSubscribeToCookies = initialValues => {
  // Memoize to avoid removing and re-adding subscriptions each time this hook is called.
  const subscription = useMemo(() => ({
    getCurrentValue: () => {
      return getAllCookies(initialValues);
    },
    subscribe: callback => {
      return onCookieChanged(callback);
    }
  }), [initialValues]);

  // Component will automatically be re-rendered when that value changes.
  return useSubscription(subscription);
};
export { useSubscribeToCookies as default };
//# sourceMappingURL=useSubscribeToCookies.js.map
